import { query } from './query'

export const comparisionListingPageQuery = {
  query,
  mocks: {
    defaultData: null,
  },
}
